<div class="gl-table__container">
  <gl-table
    [id]="listId"
    [dataSource]="dataSource"
    data-testid="gamesTable"
    [placeholder]="'actions.noResultTable' | translate"
    paginator
    scroll
    (onClickRow)="onClickRow($event.detail.data)"
    (onDatasourceUpdate)="onDatasourceUpdate($event.detail.dataSource)"
  >
  </gl-table>
</div>
